export default __webpack_public_path__ + "static/media/03_DAIF_Eco_02_AMD_end.824b17f3.jpg";